import firebase from "firebase/app";

import { useMemo } from "react";

import { db } from "astrid-firebase";
import useCollectionDataByIds from "astrid-firestore/src/hooks/useCollectionDataByIds";

import sortArticles from "../../articles/utils/sortArticles";

export default function useProductionArticles(production) {
	const [articles, loading, error] = useCollectionDataByIds(
		firebase,
		db.collection("articles").where("deleted", "==", false),
		production.articleIds,
	);

	const sortedArticles = useMemo(() => sortArticles(articles), [articles]);

	return [sortedArticles, loading, error];
}
